<template>
  <div>
    <base-header
      class="pb-6 pt-4"
      :type="$route.meta.headerClass ? $route.meta.headerClass : 'success'"
    >
    </base-header>
    <!--    New Pre-approved User-->
    <modal :show.sync="showAddModal" size="lg" modal-classes="modal">
      <div v-if="!creating">
        <form class="new-user--form">
          <!-- <base-input label="Player">
          <el-select
            input-classes="form-control"
            v-model="player"
            filterable
            placeholder="Select here"
          >
            <el-option
              v-for="play in players"
              :key="play.id"
              :label="play.label"
              :value="play.id"
            >
            </el-option>
          </el-select>
        </base-input> -->

          <!-- <base-checkbox v-model="commercialContents"
          >Stream contains commercial messages, adverts or logos?</base-checkbox
        > -->
        </form>
        <div class="row">
          <div class="col-6" />
          <div class="col-3">
            <base-button block type="success" @click="createStream"
              >Create</base-button
            >
          </div>
          <div class="col-3">
            <base-button block type="secondary" @click="showAddModal = false"
              >Cancel</base-button
            >
          </div>
        </div>
      </div>
      <div v-else>
        <loading-spinner></loading-spinner>
      </div>
    </modal>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <div class="card-wrapper">
            <!-- Form controls -->
            <div class="card">
              <!-- Card header -->
              <div class="card-header">
                <h3 class="mb-0">Set Up</h3>
              </div>
              <!-- Card body -->
              <div class="card-body">
                <p v-if="matchIdFromQuery" class="text-muted small mb-3">
                  <code>matchId</code> is set in the URL. This will create an
                  <strong>AWS</strong> livestream for that fixture using the venue’s flow from
                  <router-link to="/livestreams/venue-ingest">Venue ingest</router-link>.
                </p>
                <form>
                  <div class="row align-items-center">
                    <div class="col">
                      <base-input
                        label="County / Channel Name"
                        v-model="adHocText"
                        placeholder="Enter county or channel name"
                      />
                    </div>
                    <div class="col-auto" v-if="adHocText">
                      <base-button
                        v-if="!adHocWaiting"
                        type="default"
                        @click="showAddModal = true"
                      >
                        Create
                      </base-button>
                      <div v-else>
                        <loading-spinner></loading-spinner>
                      </div>
                    </div>
                  </div>
                  <!-- <base-input label="Date From">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="dateFrom"
                      placeholder="Pick"
                    >
                    </flat-picker>
                  </base-input>
                  <base-input label="Date To">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="dateTo"
                      placeholder="Pick"
                    >
                    </flat-picker>
                  </base-input> -->
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Competition fixture picker removed; streams now created by County / Channel Name -->
    </div>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
// import axios from "axios";
// import VueAxios from "vue-axios";
import { Firebase } from "@/firebase.js";
export default {
  name: "new-brief",
  components: {
    flatPicker,
  },
  data() {
    return {
      showAddModal: false,
      player: "",
      commercialContents: true,
      creating: false,
      adHocText: '',
      adHocWaiting: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    users() {
      return this.$store.getters["users/users"];
    },
    loading() {
      return this.$store.getters["user/loading"];
    },
    config() {
      return this.$store.getters["config/config"];
    },
    matchIdFromQuery() {
      const q = this.$route && this.$route.query && this.$route.query.matchId;
      return q ? String(q).trim() : "";
    },
  },
  methods: {
    createAdHocStream() {
      this.adHocWaiting = true;
      const payload = {
        name: this.adHocText,
        tournament: "custom",
        commercialContents: this.commercialContents,
      };
      if (this.matchIdFromQuery) {
        payload.provider = "aws";
        payload.matchId = this.matchIdFromQuery;
      }
      var publish = Firebase.app()
        .functions("europe-west2")
        .httpsCallable("addStream");
      publish(payload)
        .then((result) => {
          console.log(result);
          this.showAddModal = false;
          this.adHocWaiting = false;
          const id = result.data.id;
          const path =
            result.data.provider === 'aws'
              ? `/livestreams/aws-stream/${id}`
              : `/livestreams/stream/${id}`;
          this.$router.push(path);
        })
        .catch((error) => {
          // Getting the Error details.
          var code = error.code;
          var message = error.message;
          var details = error.details;
          console.log(error);
          this.adHocWaiting = false;
        });
    },
    createStream() {
      this.createAdHocStream();
    },
  },
};
</script>
<style>
.form-control {
  color: #606266;
}
</style>
